import { faEllipsisV, faEarthAsia, faSearch, faBars, faEdit, faL } from '@fortawesome/free-solid-svg-icons';
import { MessageService } from '../../../app/core/web-socket/message.service';
import { Component, Renderer2, ElementRef, ViewChild, ChangeDetectorRef, HostListener } from '@angular/core';
import { PreviousDataService } from 'src/app/core/services/previous-gyan/previous-data.service';
import { faSignIn, faKey, faSync, faFileExport, faTrash, faLock, faSignOut, faPlus, faMinus, faFolder, faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { LoginComponent } from '../login/login.component';
import { SignupComponent } from '../signup/signup.component';
import { GetproComponent } from '../getpro/getpro.component';

import { trigger, state, style, animate, transition } from '@angular/animations';
import { ArticleService } from './../../core/services/articles/article.service';
import { AuthService } from './../../core/services/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from './../../core/services/local-storage/local-storage.service';
import { CommonServiceService } from 'src/app/core/services/common-service/common-service.service';
import { SubmitgyanService } from './../../core/services/submit-gyan/submitgyan.service';
import { BreadcrumbService } from '../gyan-organisation/breadcrumb/breadcrumb.service';
import { MoveBreadcrumbService } from '../gyan-organisation/moveBreadcrumb/moveBreadcrumb.service';
import { Subscription } from 'rxjs';
import { Tooltip } from 'bootstrap';
import { environment } from 'src/environments/environment';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ResizeEvent } from 'angular-resizable-element';
import { Input } from '@angular/core';

interface TopicOutline {
    text: string;
    children: any;
    // Add other properties as needed
}
@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    animations: [
        trigger('expandCollapse1', [
            state(
                'expanded',
                style({
                    width: '16.66%',
                }),
            ),
            state(
                'collapsed',
                style({
                    width: '4%',
                }),
            ),
            transition('expanded => collapsed', [animate('0.1s')]),
            transition('collapsed => expanded', [animate('0.1s')]),
        ]),
        trigger('expandCollapse2', [
            state(
                'expanded',
                style({
                    width: '83.3%',
                }),
            ),
            state(
                'collapsed',
                style({
                    width: '96%',
                }),
            ),
            transition('expanded => collapsed', [animate('0.1s')]),
            transition('collapsed => expanded', [animate('0.1s')]),
        ]),
    ],
})
export class DashboardComponent {
    isVerified: boolean = true;
    faLock = faLock;
    faSignOut = faSignOut;
    faBars = faBars;
    faEdit = faEdit;
    faEllipsisV = faEllipsisV;
    faEarthAsia = faEarthAsia;
    faFileExport = faFileExport;
    faSearch = faSearch;
    faSync = faSync;
    isHideTab = false;
    faTrash = faTrash;
    showOptionsBox = false;
    isPreviousListOpen = false; // Add this variable to track the state of previous list
    faGoogle = faGoogle;
    faSignIn = faSignIn;
    faKey = faKey;
    faPlus = faPlus;
    faMinus = faMinus;
    faFolder = faFolder;
    faCaretRight = faCaretRight;
    faCaretDown = faCaretDown;
    isExpanded: { [key: string]: boolean } = { all: true };
    folderId: any;
    toggleFolderId: any;
    sortType = 'date';
    sortBy = 'desc';
    isBlack: boolean = false;
    selectedList = [
        {
            name: 'selectSources',
            isBlack: false,
        },
        {
            name: 'previousSearch',
            isBlack: false,
        },
        {
            name: 'draft',
            isBlack: false,
        },
    ];
    pageSize: number = 0;
    pageSizeAQ: number = 0;
    previousGyanList: any = {
        eachGyanResponseList: [],
    };
    json = {
        personId: this.authService.getPersonId(),
        filter: {
            gyanFamily: ['RAPID'],
            offset: this.pageSize.toString(),
            limit: '10',
        },
    };

    currentPath: Array<any> = [];
    selecteditem: any = null;
    showMoveLoader = false;
    currentFolders = [];
    errorFetchingFolder: string | undefined;
    moveError = '';
    multiSelected: Array<any> = [];
    selectedFolderId: any = null;
    showBreadcrumb = true;
    isMoveItemActive = false;

    previousAdvanceQueryList: any = [];
    recentSearchQueryList: any = [];
    folderData: { [folderId: number]: Array<any> } = {};
    isLoadingNestedByFolder: { [folderId: number]: boolean } = {};
    folderActiveState: { [key: string]: boolean } = {};

    json1: any = {
        filters: {
            gyanFamily: ['ADVANCED'],
            offset: this.pageSizeAQ.toString(),
            limit: '20',
            orderBy: this.sortType,
            order: this.sortBy,
        },
        isViewAll: 'true',
        searchFrom: 'All Searches',
    };

    hoverState: { [key: string]: boolean } = {};
    //firstTimeLoad: boolean = true;
    renamingNodeId: number | null = null;
    renamingNodeIdadvanceQuery: number | null = null;
    newName: string = '';
    newNameadvanceQueery: string = '';

    @ViewChild('renameInput') renameInput!: ElementRef;

    @ViewChild(GetproComponent) GetproModal!: GetproComponent;
    @ViewChild(LoginComponent) logInModal!: LoginComponent;
    @ViewChild(SignupComponent) signUpModal!: SignupComponent;
    @ViewChild('optionsBox') optionsBox!: ElementRef;
    @ViewChild('scrollTopDiv') scrollTopDiv: ElementRef | undefined;

    private callPreviousSearchGyan: Subscription;
    private scrollToTop: Subscription;
    private RefreshAdvancedQueries: Subscription;
    private ReOpenAdvancedQueries: Subscription;

    private showAdvancyQueryFormPage: Subscription;
    private GyanStatus: Subscription;

    private topicClickEvent: Subscription;
    private callAllTopicDetailsEvent: Subscription;
    private callFindByNameEvent: Subscription;
    private callSubmitGyanEvent: Subscription;
    private callTopicDetailsEvent: Subscription;
    private callTopicUpdateEvent: Subscription;
    private callAllTopicWithParamEvent: Subscription;
    private callMoveTopicEvent: Subscription;

    isMobile: boolean = false;
    removeDisabled: boolean = false;
    gyanLocaldata: any;
    advanceQueryLocaldata: any;

    isLoading: boolean = true;
    isLoadingPreviousGyanList: boolean = true;
    isLoadingPreviousGyanAllList: boolean = true;
    isLoadingadvanceQueryList: boolean = true;
    signInUser: boolean = false;
    isLoadingNested: boolean = false;
    isTopicLoading = true;
    preWarmACIPermission: boolean = false;
    RapidQueryListPermission: boolean = false;

    isGyanSelected = false;
    // topicOutline: TopicOutline = {
    //     text: '',
    //     children: [
    //         {
    //             id: 0,
    //             text: '',
    //         },
    //     ],
    // };
    topicOutline: any = {};
    //topicId = 0;
    gyanVersion = '';
    topicOutlineArray = [];
    selectedTopic: any = null;
    callTopicDetails = true;
    searchText = '';
    metaData: any;
    totalCount = 0;
    topicDetailsOffset = 0;
    findByNameOffset = 0;
    countIncr = 0;
    currentTopicPath: any = [];

    private globalClickListener!: () => void;
    rootStatus: any;
    returnFolderData = false;
    entireFolderArray: any = [];
    highlightFolderId: any;

    topicIdTobeDeleted: any;
    topicTobeDeleted: any;
    deleteMessage = '';
    private modalRef: NgbModalRef | undefined;

    editGyanPermission = false;
    createGyanPermission = false;
    deleteGyanPermission = false;
    CreateFolderPermission = false;

    SelectSourcesPermission: boolean = false;
    SimpleResearchPermission: boolean = false;
    AdvancedResearchPermission: boolean = false;
    ContentPermission: boolean = false;
    SettingsPermission: boolean = false;
    DeleteAdvancedResearchPermission: boolean = false;
    DeleteSimpleReseachPermission: boolean = false;
    RenameAdvancedResearchPermission: boolean = false;
    RenameSimpleReseachPermission: boolean = false;
    public style: object = {};
    resizeEndFlag = false;
    rootTopicId: any;
    isPreviousSearchonFlag: boolean = false;
    hasAdminAccess: boolean = false;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
        private previousDataService: PreviousDataService,
        // private advanceQueryService: advanceQueryService,
        private cdr: ChangeDetectorRef,
        private authService: AuthService,
        private messageService: MessageService,
        private toastrService: ToastrService,
        private localStorageService: LocalStorageService,
        private commonServiceService: CommonServiceService,
        private commonServService: CommonServiceService,
        private articleService: ArticleService,
        private submitgyanservice: SubmitgyanService,
        private breadcrumbService: BreadcrumbService,
        private moveBreadcrumbService: MoveBreadcrumbService,
        private modalService: NgbModal,
    ) {
        this.checkWidth();

        // calling subject to load articles by taking gyan id from localstorage
        this.callPreviousSearchGyan = this.commonServiceService.callPreviousSearchGyan$.subscribe((value) => {
            if (value) {
                this.isAdvanceQueryOpen = false;

                this.isPreviousSearchOpen = this.isPreviousSearchonFlag;
                this.isVerified = this.authService.getIsVerified() === 'true';
                if (this.isVerified && ((this.isSignInUser() && this.isPreviousSearchOpen) || !this.isSignInUser())) {
                    //this.isPreviousSearchOpen = false;
                    this.previousSearchAll();
                    this.gyanLocaldata = this.localStorageService.getItem('gyanData');
                } else {
                    this.isPreviousSearchonFlag = true;
                }
            }
        });

        // calling subject to load articles by taking gyan id from localstorage
        this.scrollToTop = this.commonServiceService.scrollToTop$.subscribe((value) => {
            if (value) {
                console.log(value);
                if (this.scrollTopDiv) {
                    this.scrollTopDiv.nativeElement.scrollIntoView({ behavior: 'smooth' });
                    this.scrollTopDiv.nativeElement.scrollTo({ top: 0, duration: 100 });
                }
            }
        });
        this.ReOpenAdvancedQueries = this.commonServiceService.ReOpenAdvancedQueries$.subscribe((value) => {
            if (value) {
                console.log('ReOpenAdvancedQueries - this is called');
                this.isLoadingAQ = false;
                this.folderId = '';
                this.rootTopicId = '';
                this.isGyanSelected = false;
                this.gyanLocaldata = null;
                if (this.isExpanded['all']) {
                    this.toggleNode({ topicId: 'all' }, null);
                }
                this.toggleColor('adavanceQuery');
                ///  this.toggleFolder(null,null);
                //alert('ada');
            }
        });
        this.RefreshAdvancedQueries = this.commonServiceService.RefreshAdvancedQueries$.subscribe((value) => {
            if (value) {
                console.log('RefreshAdvancedQueries - this is called');
                this.isLoadingAQ = true;
                this.folderId = '';
                this.advanceQueryAll('');
                this.advanceQueryLocaldata = this.localStorageService.getItem('gyanData');
                const topic = this.localStorageService.getItem('gyanData');
                setTimeout(() => {
                    this.AdvanceQuerySelected(topic.gyanName, topic.gyanId, topic.gyanStatus);
                }, 10);
            }
        });

        //calling subject to load Advance Query form
        this.showAdvancyQueryFormPage = this.commonServiceService.showAdvancyQueryFormPage$.subscribe((value) => {
            if (value) {
                this.isAdvanceQueryOpen = true;
                this.isPreviousSearchOpen = false;
                setTimeout(() => {
                    this.commonServiceService.setShowAdvancyQueryFormPage(false);
                }, 100);
            }
        });

        //below subject is to update the gyan status when it is finished (for subtopics)
        this.GyanStatus = this.commonServiceService.CallFromSocketForGyanStatus$.subscribe((value) => {
            if (value) {
                this.rootStatus = 'FINISHED';
            }
        });

        this.topicClickEvent = this.previousDataService.topicClickEvent$.subscribe((data) => {
            console.log('ngOnInit.topicClickEvent.data', data);
            this.AdvanceQuerySelected(data.topicName, data.topicId, data.topicStatus);
        });

        this.callAllTopicDetailsEvent = this.previousDataService.callAllTopicDetailsEvent$.subscribe(() => {
            console.log('ngOnInit.callAllTopicDetailsEvent.ngOnInit');
            this.folderId = '';
            this.searchText = '';
            this.folderData = {};
            this.folderActiveState = {};
            this.currentTopicPath = [];
            this.breadcrumbService.updateBreadcrumbs(this.currentTopicPath);
            this.previousAdvanceQueryList = [];
            //this.closeAllFolders();
            this.advanceQueryAll('');
        });

        this.callFindByNameEvent = this.previousDataService.callFindByNameEvent$.subscribe((data) => {
            console.log('ngOnInit.callFindByNameEvent.data', data);
            this.searchText = data;
            this.findByName(data);
        });

        this.callSubmitGyanEvent = this.submitgyanservice.callSubmitGyanEvent$.subscribe((data: boolean) => {
            console.log('ngOnInit.callFindByNameEvent.data', data);
            if (this.isExpanded['all']) {
                this.toggleNode({ topicId: 'all' }, null);
            }
            this.toggleColor('adavanceQuery');
            this.isPreviousSearchOpen = false;
            this.isAdvanceQueryOpen = true;
            //this.showSubmitGyan = data;
        });

        this.callTopicDetailsEvent = this.previousDataService.callTopicDetailsEvent$.subscribe((topcicId) => {
            console.log('ngOnInit.onScrollDownAQ');
            this.folderId = topcicId;
            this.highlightFolder(topcicId);
            //this.closeAllFolders();
            console.log('callTopicDetailsEvent.topcicId', topcicId);
            this.advanceQueryAll('');
        });

        this.callTopicUpdateEvent = this.previousDataService.callTopicUpdateEvent$.subscribe((data) => {
            console.log('ngOnInit.callTopicUpdateEvent.data', data);
            this.folderId = data.parentFolderId;
            if (data.type == 'delete') {
                this.updateTopicDeleteArrayFunction(data.topicId);
            } else {
                this.updateTopicArrayFunction(data.topicId, data.topicName, data.type, data.parentFolderId);
            }
        });

        this.callAllTopicWithParamEvent = this.previousDataService.callAllTopicWithParamEvent$.subscribe((data: any) => {
            console.log('ngOnInit.callAllTopicWithParamEvent.data', data);
            this.sortType = data.sortType;
            this.sortBy = data.sortBy;
            if (this.searchText) {
                this.findByName(this.searchText);
            } else {
                this.advanceQueryAll('');
            }
        });

        this.callMoveTopicEvent = this.previousDataService.callMoveTopicEvent$.subscribe((data) => {
            console.log('ngOnInit.callMoveTopicEvent.data', data);
            this.updateTopicMoveArrayFunction(data.topicIdArray, data.sourceFolderId, data.destinationFolderId);
        });

        this.breadcrumbService.currentBreadcrumbs.subscribe((breadcrumbs) => {
            this.currentTopicPath = breadcrumbs;
        });
    }

    toggleNode(AdvanceQuery: any, event: any): void {
        if (event !== null) {
            event.stopPropagation(); // Prevents the event from bubbling up and triggering other handlers.
        }

        const key = AdvanceQuery.topicId;
        this.isExpanded[key] = !this.isExpanded[key];
        console.log('toggleNode.folderData', this.folderData);
        if (key !== 'all' && !this.folderData[key]) {
            //this.folderId = key;
            this.advanceQueryAll(key);
        } else {
            console.log('toggleNode.All');
            this.refreshThepreviousAdvanceQueryList();
        }
    }

    onResizeEnd(event: ResizeEvent): void {
        this.resizeEndFlag = true;
        this.style = {
            width: `${event.rectangle.width}px`,
            borderRight: `6px solid #F6F6F6`,
        };
        if (event.edges.right == 0 || (typeof event.edges.right === 'number' && event.edges.right <= 0)) {
            this.resetSize();
            this.resizeEndFlag = false;
        }
    }

    resetSize() {
        this.style = {};
    }

    toggleFolder(AdvanceQuery: any, event: any): void {
        if (event !== null) {
            event.stopPropagation(); // Prevents the event from bubbling up and triggering other handlers.
        }
        this.localStorageService.setItem('rootGyanId', '');
        this.rootTopicId = '';
        this.topicOutline = {};
        this.isGyanSelected = false;
        this.advanceQueryLocaldata = null;
        this.resetSize();
        const key = AdvanceQuery.topicId;
        for (const folderKey in this.folderActiveState) {
            if (this.folderActiveState.hasOwnProperty(folderKey)) {
                this.folderActiveState[folderKey] = false;
            }
        }

        // Set the active state for the currently selected folder
        this.folderActiveState[key] = true;
        if (key !== 'all') {
            this.folderId = key;
            this.returnFolderData = true;
            this.currentTopicPath = [];
            const parentsWithObjects = this.findAllParentsWithObjects(key, this.folderData);

            if (parentsWithObjects && parentsWithObjects.length > 0) {
                const lastItem = parentsWithObjects[parentsWithObjects.length - 1];
                const foundItem = this.previousAdvanceQueryList.find((item: any) => item.topicId == lastItem.key);
                if (foundItem) {
                    this.currentTopicPath.push(foundItem);
                }
                // Reverse to ensure order from root to current topic
                parentsWithObjects.reverse().forEach((parent) => {
                    this.currentTopicPath.push(parent.object);
                });
            } else {
                console.log(`No parent found for ${key}`);
                const foundItem = this.previousAdvanceQueryList.find((item: any) => item.topicId == key);
                if (foundItem) {
                    this.currentTopicPath.push(foundItem);
                }
            }
            this.breadcrumbService.updateBreadcrumbs(this.currentTopicPath);
            this.advanceQueryAll('');
        }
    }

    findAllParentsWithObjects(targetTopicId: number, topics: Record<string, Array<any>>): Array<{ key: string; object: any }> {
        const parents: Array<{ key: string; object: any }> = [];

        // Recursive function to find the parent key and object
        const findParentKeyAndObject = (currentTopicId: number): { key: string; object: Array<any> } | null => {
            for (const [key, value] of Object.entries(topics)) {
                const found = value?.find((item: any) => item.topicId === currentTopicId);
                if (found) {
                    return { key, object: found }; // Return both the parent key and the associated object
                }
            }
            return null;
        };

        // Loop to keep finding parents until there are no more
        let parentInfo = findParentKeyAndObject(targetTopicId);
        while (parentInfo) {
            parents.push(parentInfo); // Add the parent key and object to the list
            parentInfo = findParentKeyAndObject(Number(parentInfo.key)); // Find the parent of the current parent
        }

        return parents;
    }

    isFolderActive(topicId: any): boolean {
        return !!this.folderActiveState[topicId];
    }

    isFolderExpanded(folderId: string): boolean {
        return this.isExpanded[folderId];
    }

    isVerifiedUser() {
        return this.isVerified;
    }
    isLoadPreviousGyanList: boolean = false;
    ngOnInit() {
        //this.accesList();

        this.localStorageService.setItem('rootGyanId', '');
        // alert(this.rootTopicId);
        this.closeMenuOnOutsideClick();
        //commented this code for not calling enterprise research on load
        // if (!this.isLoadPreviousGyanList) {
        //     this.isPreviousSearchOpen = true;
        //     this.previousSearchAll();
        // }
        this.isLoadingPreviousGyanAllList = false;
        this.isVerified = this.authService.getIsVerified() === 'true';

        //this.firstTimeLoad = true;
        setTimeout(() => {
            this.isLoading = false;
            const details = this.localStorageService.getItem('userDetails');
            console.log('details are this', details);
            if (details?.roles == 'ADMIN') this.hasAdminAccess = true;
            else this.hasAdminAccess = false;
            this.getAccessPermission();
        }, 2000);
        this.gyanLocaldata = this.localStorageService.getItem('gyanData');

        this.previousDataService.scrollEvent$.subscribe((data) => {
            console.log('ngOnInit.onScrollDownAQ');
            this.searchText = data;
            this.onScrollDownAQ();
        });
        this.commonServService.showDraftListPage$.subscribe((data) => {
            if (data) {
                this.isDraftOpen = true;
                this.isPreviousSearchOpen = false;
                this.isAdvanceQueryOpen = true;
            } else {
                this.isDraftOpen = false;
            }
        });
    }

    getAccessPermission() {
        this.editGyanPermission = this.authService.getAccessList('EditGyan');
        this.deleteGyanPermission = this.authService.getAccessList('DeleteGyan');
        this.createGyanPermission = this.authService.getAccessList('CreateGyan');
        this.CreateFolderPermission = this.authService.getAccessList('CreateFolder');

        this.SelectSourcesPermission = this.authService.getAccessList('SelectSources');
        this.SimpleResearchPermission = this.authService.getAccessList('SimpleSearch');
        this.AdvancedResearchPermission = this.authService.getAccessList('CreateGyan');
        this.ContentPermission = this.authService.getAccessList('Content');
        this.SettingsPermission = this.authService.getAccessList('Settings');
        this.DeleteSimpleReseachPermission = this.authService.getAccessList('DelSimpleResearch');
        this.DeleteAdvancedResearchPermission = this.authService.getAccessList('DelAdvancedResearch');
        this.RenameSimpleReseachPermission = this.authService.getAccessList('RenameSimpleResearch');
        this.RenameAdvancedResearchPermission = this.authService.getAccessList('RenameAdvancedResearch');
    }

    highlightFolder(topcicId: any) {
        if (this.isMobile) {
            this.hideTab();
        }
        this.returnFolderData = true;
        for (const folderKey in this.folderActiveState) {
            if (this.folderActiveState.hasOwnProperty(folderKey)) {
                this.folderActiveState[folderKey] = false;
            }
        }

        // Set the active state for the currently selected folder
        this.folderActiveState[topcicId] = true;
    }

    // accesList() {
    //              // console.log('preWarmACIPermission',this.preWarmACIPermission)
    // }

    onButtonHover(event: MouseEvent) {
        console.log('Hovered:', event);
        // Implement your logic here
    }

    ngAfterViewChecked() {
        if (this.renamingNodeId !== null && this.renameInput) {
            this.renameInput.nativeElement.focus();
        }
    }
    @ViewChild('scrollContainer') scrollContainer!: ElementRef;
    lastPageSize: number = 0;
    lastResultCount: number = 10;
    // onScrollDown() {
    //     console.log("onScrollDown called")
    //     const container = this.scrollContainer.nativeElement;
    //     if (this.lastResultCount == 10 && this.authService.getIsGuest() === 'false' && container.scrollTop + container.clientHeight + 0.4 >= container.scrollHeight) {
    //         this.pageSize = this.pageSize + 1;
    //         this.json = {
    //             personId: this.authService.getPersonId(),
    //             filter: {
    //                 gyanFamily: ['RAPID'],
    //                 offset: (this.pageSize * 10).toString(),
    //                 limit: '10',
    //             },
    //         };
    //         this.previousSearch();
    //     }
    //     else{
    //         console.log("onScrollDown called else")
    //     }
    // }

    onScrollDown() {
        console.log('onScrollDown called');
        this.closeOption();
        this.pageSize = this.pageSize + 1;
        this.json = {
            personId: this.authService.getPersonId(),
            filter: {
                gyanFamily: ['RAPID'],
                offset: (this.pageSize * 10).toString(),
                limit: '20',
            },
        };
        this.previousSearch();
    }

    @ViewChild('scrollContainerAQ') scrollContainerAQ!: ElementRef;

    lastPageSizeAQ: number = 0;
    lastResultCountAQ: number = 10;

    onScrollDownAQ() {
        console.log('onScrollDownAQ Called.searchText', this.searchText);
        this.closeOption();
        this.pageSizeAQ = this.pageSizeAQ + 1;
        this.json1 = {
            filters: {
                gyanFamily: ['ADVANCED', 'TEMPLATE', 'SENTENCE'],
                offset: this.previousAdvanceQueryList.length,
                //limit: '10',
                limit: '20',
                orderBy: this.sortType,
                order: this.sortBy,
            },
            isViewAll: 'true',
            searchFrom: 'All Searches',
        };
        this.isLoadingAQ = true;
        if (this.searchText && this.searchText.trim() !== '') {
            this.callFindByName();
        } else {
            const topic = this.currentTopicPath[this.currentTopicPath.length - 1];
            if (topic) {
                this.json1.filters['folderId'] = topic.topicId;
            }
            this.AdvanceQuery();
        }
    }

    onRenameInputBlur(event: any, nodeId: number, previousGyan: any) {
        if (this.renamingNodeId !== null && this.renamingNodeId !== undefined) {
            // if (event.type === 'blur' || event.key === 'Enter') {
            this.saveRename(nodeId, previousGyan);

            //}
        }
    }
    onRenameAQInputBlur(event: any, nodeId: number, previousGyan: any) {
        if (this.renamingNodeIdadvanceQuery !== null && this.renamingNodeIdadvanceQuery !== undefined) {
            // if (event.type === 'blur' || event.key === 'Enter') {
            this.saveRenameAQ(nodeId, previousGyan);

            //}
        }
    }
    selectedGyanId: number = 0;
    selectedGyanName: string = '';
    selectedtopicId: number = 0;
    selectedtopicName: string = '';

    previousGyanSelectedGeneral(gyanName: any, gyanId: any) {
        this.resetSize();
        this.localStorageService.removeItem('articleClickIndex');
        this.commonServiceService.setSelectedId('');
        const gyanData = { gyanName: gyanName, gyanId: gyanId, gyanType: 'rapid', clickbackfromgyan: 'No', gyanCreatedNow: 'no' };
        this.selectedGyanId = gyanId;
        this.selectedGyanName = gyanName;
        this.gyanLocaldata = gyanData;
        this.localStorageService.setItem('gyanData', gyanData);
        const obj = {
            callMDS: true,
            callArticles: true,
        };
        this.commonServiceService.setPreviousGyanClick(obj);
    }

    previousadvanceQuerySelectedGeneral(topicName: any, topicId: any, topicStatus: any, callType: string) {
        // debugger;
        console.log('the call type and status sent is', callType, topicStatus);
        this.commonServiceService.setSelectedId('');
        // if(callType === 'topic' )
        //     if(topicStatus == 'FINISHED' || 'FAIL' || 'NO_ARTICLE_IN_SEARCH'){
        //     const obj = {
        //         callMDS: true,
        //         callArticles: true,
        //         callType: false,
        //     };
        //     this.commonServiceService.setPreviousGyanClick(obj);
        // }

        // else {
        //     const obj = {
        //         callMDS: true,
        //         callArticles: true,
        //         callType: true,
        //     };
        //     this.commonServiceService.setPreviousGyanClick(obj);
        // }

        const gyanData = { gyanName: topicName, gyanId: topicId, gyanType: 'gyan', clickbackfromgyan: 'No', gyanCreatedNow: 'no', gyanStatus: topicStatus, callType };
        this.selectedtopicId = topicId;
        this.selectedtopicName = topicName;
        this.advanceQueryLocaldata = gyanData;
        this.localStorageService.setItem('gyanData', gyanData);
        //}
        const obj = {
            callMDS: true,
            callArticles: true,
            callType: callType === 'topic' ? true : false,
        };
        this.commonServiceService.setPreviousGyanClick(obj);
    }
    previousGyanSelected(gyanName: any, gyanId: any) {
        this.previousGyanSelectedGeneral(gyanName, gyanId);
        if (this.isMobile) {
            this.hideTab();
        }
        // this.selectedGyan = rootNodeId;
        //  this.createGyanService.callWebsocket.next(false);
    }

    AdvanceQuerySelected(topicName: any, topicId: any, topicStatus: any) {
        this.resetSize();
        this.localStorageService.removeItem('articleClickIndex');
        this.renamingNodeIdadvanceQuery = null;
        this.folderId = '';
        this.rootStatus = topicStatus;
        console.log('AdvanceQuerySelected func called and the status is', topicStatus);
        this.folderActiveState = {};
        this.isDraftOpen = false;
        this.callGetTopicHierarchy(topicId);
        this.previousadvanceQuerySelectedGeneral(topicName, topicId, this.rootStatus, 'gyan');
        if (this.isMobile && this.isHideTab) {
            this.hideTab();
        }
        //this.toggleNode({ topicId: 'all' });
        // this.selectedGyan = rootNodeId;
        //  this.createGyanService.callWebsocket.next(false);
    }

    // AdvanceQuerySelected(gyanName: any, gyanId: any) {
    //     console.log('AQName', gyanName);
    //     console.log('AQId', gyanId);
    //     this.commonServiceService.setSelectedId('');
    //     const AQData = { gyanName: gyanName, gyanId: gyanId, gyanType: 'gyan', gyanCreatedNow: 'NO' };
    //     this.selectedAQId = gyanId;
    //     this.selectedGyanName = gyanName;
    //     this.AQLocaldata = AQData;
    //     this.localStorageService.setItem('gyanData', AQData);
    //     const obj = {
    //         callMDS: true,
    //         callArticles: true,
    //     };
    //     this.commonServiceService.setPreviousGyanClick(obj);
    //     if (this.isMobile) {
    //         this.hideTab();
    //     }
    //     // this.selectedGyan = rootNodeId;
    //     //  this.createGyanService.callWebsocket.next(false);
    // }
    toggleClickPS() {
        this.localStorageService.setItem('rootGyanId', '');
        if (!this.isPreviousSearchOpen) {
            this.onPreviousGyanClick();
        }
        this.hideTab();
    }
    toggleClickAQ() {
        this.localStorageService.setItem('rootGyanId', '');
        if (this.isSignInUser() && !this.isAdvanceQueryOpen) {
            this.advanceClick();
        }
        this.hideTab();
    }
    hideTab() {
        this.isHideTab = !this.isHideTab;
    }
    refreshGyan(previousGyan: any) {}
    exportGyan(previousGyan: any) {}
    deleteGyan(id: any) {
        this.closeOption();
        this.previousDataService.deleteGyan(id, this.authService.getPersonId()).subscribe((data: any) => {
            if (data.statusCode === 200) {
                this.toastrService.success(data.message);
                // Remove the item from the list
                const indexGyan = this.previousGyanList.eachGyanResponseList.findIndex((gyan: any) => gyan.rootNodeId !== id);
                this.previousGyanList.eachGyanResponseList = this.previousGyanList.eachGyanResponseList.filter((gyan: any) => gyan.rootNodeId !== id);

                if (this.selectedGyanId == id && this.previousGyanList.eachGyanResponseList.length > 0) {
                    this.selectedGyanId = this.previousGyanList.eachGyanResponseList[0].rootNodeId;
                    this.selectedGyanName = this.previousGyanList.eachGyanResponseList[0].name;
                    this.previousGyanSelected(this.selectedGyanName, this.selectedGyanId);
                }
                // Redirect to dashboard home for Mobile View
                else {
                    this.selectedGyanId = this.previousGyanList.eachGyanResponseList[0].rootNodeId;
                    this.selectedGyanName = this.previousGyanList.eachGyanResponseList[0].name;
                    console.log('the selected name and the id is', this.selectedGyanName, this.selectedGyanId);
                    this.previousGyanSelected(this.selectedGyanName, this.selectedGyanId);
                    // this.isPreviousSearchOpen = false;
                    if (this.isMobile) {
                        this.hideTab();
                    }
                }
                // Redirect to dashboard home
                this.previousSearch();

                //this.previousSearch();
            }
        });
    }
    deleteTopic(topic: any) {
        this.closeOption();
        //debugger;
        this.previousDataService.deleteTopic(topic.topicId, this.authService.getPersonId()).subscribe((data: any) => {
            // debugger;
            //if (data.statusCode === 200) {
            // debugger;
            if (this.modalRef) {
                this.modalRef.close();
            }
            this.toastrService.success(data.message);
            // Remove the item from the list
            const indexadvanceQuery = this.previousAdvanceQueryList.findIndex((advanceQueryData: any) => advanceQueryData.topicId !== topic.topicId);
            this.previousAdvanceQueryList = this.previousAdvanceQueryList.filter((advanceQueryData: any) => advanceQueryData.topicId !== topic.topicId);

            this.updateTopicDeleteArrayFunction(topic.topicId);
            // this.recentSearchQueryList = JSON.parse(JSON.stringify(this.previousAdvanceQueryList));
            // this.previousDataService.emitCallAllTopicDataClickEvent(this.recentSearchQueryList);

            if (this.selectedtopicId == topic.topicId && this.previousAdvanceQueryList.length > 0) {
                const firstNonFolderItem = this.previousAdvanceQueryList.find((item: any) => !item.isFolder);
                if (firstNonFolderItem) {
                    this.selectedtopicId = firstNonFolderItem.topicId;
                    this.selectedtopicName = firstNonFolderItem.topicName;
                    this.AdvanceQuerySelected(this.selectedtopicName, this.selectedtopicId, '');
                }
            } else {
                this.isAdvanceQueryOpen = this.previousAdvanceQueryList.advanceQueryData.length > 0;
                // this.isAdvanceQueryOpen = false;
                if (this.isMobile) {
                    this.hideTab();
                }
            }
        });
    }

    checkForDeleteGyan1(topic: any) {
        this.closeOption();
        this.previousDataService.emitDeleteClickEvent(topic);
    }

    checkForDeleteGyan(topic: any, content: any) {
        this.closeOption();
        console.log('callDeleteGyan.checkForDeleteGyan', topic);
        if (topic.isFolder) {
            this.topicIdTobeDeleted = topic.topicId;
            this.topicTobeDeleted = topic;
            this.callDeleteGyan();
            //this.deleteMessage = 'Are you sure you want to delete this folder?';
        } else {
            const personId = this.authService.getPersonId();
            if (topic.topicOwnerId == personId) {
                if (topic.topicSharedWith.length == 0) {
                    this.deleteMessage = 'Are you sure you want to delete this topic?';
                } else if (topic.topicSharedWith.length > 0) {
                    this.deleteMessage = 'This topic has been shared with other users, Are you sure you want to delete?';
                }
            } else {
                this.deleteMessage = 'Are you sure you want to delete this topic?';
            }
            this.modalRef = this.modalService.open(content, { size: 'sm', centered: true, windowClass: 'custom-modal-class' });
            this.topicIdTobeDeleted = topic.topicId;
            this.topicTobeDeleted = topic;
            console.log('checkForDeleteGyan.topic', topic);
        }
    }

    callDeleteGyan() {
        const item = this.topicTobeDeleted;
        console.log('callDeleteGyan.item', item);
        if (item?.isFolder) {
            this.previousDataService.deleteFolder(item.topicId).subscribe(
                (resp: any) => {
                    console.log('callDeleteGyan.resp', resp);
                    //this.handleDeleteGyanSuccessResponse(resp);
                    this.closeOption();
                    const index: any = this.previousAdvanceQueryList?.findIndex((selectedTag: any) => selectedTag.topicId == this.topicIdTobeDeleted);
                    this.previousAdvanceQueryList?.splice(index, 1);
                    this.toastrService.success(resp.message);
                    if (this.modalRef) {
                        this.modalRef.close();
                    }
                    this.updateTopicDeleteArrayFunction(item.topicId);
                    //const topic = this.currentTopicPath[this.currentTopicPath.length - 1];
                    //this.previousDataService.emitCallTopicUpdateClickEvent(this.topicIdTobeDeleted, '', 'delete', topic.topicId);
                },
                (err: any) => {
                    // this.spinnerComponent.hideSpinner();
                    this.toastrService.error(err.error.message);
                    this.closeOption();
                    console.log('handleDeleteGyanErrorResponse');
                    if (this.modalRef) {
                        this.modalRef.close();
                    }
                },
            );
        } else {
            this.deleteTopic(item);
        }
    }

    rename(id: any, name: any) {
        this.closeOption();
        this.renamingNodeId = id;
        this.newName = name;
    }
    @ViewChild('renameInputAQ', { static: false }) renameInputAQ?: ElementRef;
    renameAQ(topicId: any, topicName: any) {
        this.closeOption();
        this.renamingNodeIdadvanceQuery = topicId;
        this.newNameadvanceQueery = topicName;
        setTimeout(() => {
            this.renameInputAQ?.nativeElement?.focus(); // Focus on the input
        }, 0);
    }

    saveAQRename(nodeId: number, oldName: any) {
        // debugger;
        if (this.newNameadvanceQueery.toString().trim() === '') {
            this.toastrService.error('Please enter name');
        } else {
            // debugger;
            if (oldName.topicName === this.newNameadvanceQueery) {
                this.renamingNodeIdadvanceQuery = null;
                this.cdr.detectChanges();
            } else {
                oldName.topicName = this.newNameadvanceQueery;
                console.log(`Renaming node ${nodeId} to ${this.newNameadvanceQueery}`);
                this.renamingNodeIdadvanceQuery = null;
                const json1 = {
                    personId: this.authService.getPersonId(),
                    topicId: nodeId,
                    updatedName: this.newNameadvanceQueery,
                };
                this.previousDataService.renameAqGyan(json1).subscribe((data: any) => {
                    if (data.statusCode === 200) {
                        this.toastrService.success(data.message);
                        this.cdr.detectChanges(); // Ensure Angular's change detection picks up the update
                        // this.previousSearch();
                    } else if (data.statusCode === 500) {
                        this.toastrService.error(data.message);
                        this.cdr.detectChanges(); // Ensure Angular's change detection picks up the update
                        // this.previousSearch();
                    }
                });
            }
        }
    }

    // AQrename(id: any, name: any) {
    //     this.closeOption();
    //     this.renamingNodeId = id;
    //     this.newName = name;
    // }
    saveRename(nodeId: number, oldName: any) {
        if (this.newName.toString().trim() === '') {
            this.toastrService.error('Please enter name');
        } else {
            // debugger;
            if (oldName.name === this.newName) {
                this.renamingNodeId = null;
                this.cdr.detectChanges();
            } else {
                oldName.name = this.newName;
                console.log(`Renaming node ${nodeId} to ${this.newName}`);
                this.renamingNodeId = null;
                const json = {
                    personId: this.authService.getPersonId(),
                    topicId: nodeId,
                    updatedName: this.newName,
                };
                this.previousDataService.renameGyan(json).subscribe((data: any) => {
                    if (data.statusCode === 200) {
                        this.toastrService.success(data.message);
                        this.cdr.detectChanges(); // Ensure Angular's change detection picks up the update
                        // this.previousSearch();
                    } else if (data.statusCode === 500) {
                        this.toastrService.error(data.message);
                        this.cdr.detectChanges(); // Ensure Angular's change detection picks up the update
                        // this.previousSearch();
                    }
                });
            }
        }
    }
    saveRenameAQ(nodeId: number, oldName: any) {
        console.log('saveRenameAQ', oldName);
        // debugger;
        if (this.newNameadvanceQueery.toString().trim() === '') {
            this.toastrService.error('Please enter name');
        } else {
            // debugger;
            if (oldName.topicName === this.newNameadvanceQueery) {
                this.renamingNodeIdadvanceQuery = null;
                this.cdr.detectChanges();
            } else {
                oldName.topicName = this.newNameadvanceQueery;
                console.log(`Renaming node ${nodeId} to ${this.newNameadvanceQueery}`);
                this.renamingNodeIdadvanceQuery = null;
                if (oldName.isFolder) {
                    const reqBody = { folderName: this.newNameadvanceQueery };
                    // this.previousDataService.updateFolderName(nodeId, reqBody).subscribe((data: any) => {

                    // });
                    this.previousDataService.updateFolderName(nodeId, reqBody).subscribe(
                        (res: any) => {
                            console.log(`updateFolderName.res,`, res);
                            console.log(`updateFolderName.updatedName,`, this.newNameadvanceQueery);
                            //this.handleChangeTopicSuccessResponse(oldName);
                            this.toastrService.success(res.message);
                            oldName.editTopic = false;
                            if (this.currentTopicPath.length > 0) {
                                const topic = this.currentTopicPath[this.currentTopicPath.length - 1];
                                this.previousDataService.emitCallTopicUpdateClickEvent(oldName.topicId, this.newNameadvanceQueery, 'rename', topic.topicId);
                            } else {
                                this.previousDataService.emitCallTopicUpdateClickEvent(oldName.topicId, this.newNameadvanceQueery, 'rename', '');
                            }
                        },
                        (err: any) => {
                            //this.handleChangeTopicErrorResponse(oldName);
                            oldName.editTopic = false;
                            this.toastrService.error(err.message);
                        },
                    );
                } else {
                    const json1 = {
                        personId: this.authService.getPersonId(),
                        topicId: nodeId,
                        updatedName: this.newNameadvanceQueery,
                    };
                    this.previousDataService.renameAqGyan(json1).subscribe((data: any) => {
                        if (data.statusCode === 200) {
                            this.toastrService.success(data.message);
                            setTimeout(() => {
                                //this.recentSearchQueryList = JSON.parse(JSON.stringify(this.previousAdvanceQueryList));
                                //this.previousDataService.emitCallAllTopicDataClickEvent(this.recentSearchQueryList);
                                this.updateTopicArrayFunction(oldName.topicId, oldName.topicName, 'rename', this.folderId);

                                console.log('recentSearchQueryList[0]', this.recentSearchQueryList[0]);
                                this.cdr.detectChanges();
                            }, 100);
                            //this.cdr.detectChanges(); // Ensure Angular's change detection picks up the update
                            // this.previousSearch();
                        } else if (data.statusCode === 500) {
                            this.toastrService.error(data.message);
                            this.cdr.detectChanges(); // Ensure Angular's change detection picks up the update
                            // this.previousSearch();
                        }
                    });
                }
            }
        }
    }

    previousSearchAll() {
        this.isLoadingPreviousGyanAllList = true;
        console.log('previousSearchAll called');
        this.json = {
            personId: this.authService.getPersonId(),
            filter: {
                gyanFamily: ['RAPID'],
                offset: '0',
                limit: '10',
            },
        };
        this.commonServiceService.setopenSubmitGyan(false);
        this.previousDataService.getPreviousGyanData(this.json).subscribe((data: any) => {
            if (data.statusCode === 200) {
                this.isLoadingPreviousGyanList = false;
                this.previousGyanList = data.data;
                this.hoverState['previousSearch'] = false;
                this.toggleColor('previousSearch');
                this.removeDisabled = true;
                this.isLoadingPreviousGyanAllList = false;
                this.isPreviousSearchOpen = true;
                // this.isAdvanceQueryOpen = false;
            }
        });
    }

    advanceQueryAll(folderId: any) {
        console.log('advanceQueryAll.folderId', this.folderId);
        const internalFolderId = folderId ? folderId : this.folderId;
        let limit = 10;
        this.isTopicLoading = true;
        this.previousDataService.emitLoadingClickEvent(true);
        if (!this.isGyanSelected) {
            this.commonServiceService.setopenSubmitGyan(true);
        }
        //this.submitgyanservice.emitSubmitGyanClickEvent(false);
        console.log('this.authService.getIsGuest()');
        // console.log(this.authService.getIsGuest());

        if (this.pageSize > 0) {
            limit = (this.pageSize + 1) * 10;
        } else {
            let pageSize = this.authService.getPageNos();
            if (pageSize === '') {
                pageSize = '0';
            }
            const pageSizeNum = Number.parseInt(pageSize);
            //this.pageSize = pageSizeNum;
            if (pageSizeNum > 0) {
                limit = (pageSizeNum + 1) * 10;
            }
        }

        const folderIdKey = typeof internalFolderId === 'number' ? internalFolderId : 0; // Use 0 for "All" case

        // Set loading state to true
        this.isLoadingNestedByFolder[folderIdKey] = true;

        console.log('advanceQueryAll.folderId', internalFolderId);
        console.log('advanceQueryAll.recentSearchQueryList', this.recentSearchQueryList);
        const json1 =
            typeof internalFolderId === 'number'
                ? {
                      filters: {
                          gyanFamily: ['ADVANCED', 'TEMPLATE', 'SENTENCE'],
                          offset: '0',
                          //limit: '10',
                          limit: '20',
                          orderBy: this.sortType,
                          order: this.sortBy,
                          folderId: internalFolderId,
                      },
                      isViewAll: 'true',
                      searchFrom: 'All Searches',
                  }
                : {
                      filters: {
                          gyanFamily: ['ADVANCED', 'TEMPLATE', 'SENTENCE'],
                          offset: '0',
                          limit: '20',
                          orderBy: this.sortType,
                          order: this.sortBy,
                      },
                      isViewAll: 'true',
                      searchFrom: 'All Searches',
                  };
        // debugger;
        if (this.isSignInUser()) {
            this.previousDataService.getAdvanceQueryData(json1).subscribe(
                (data: any) => {
                    this.isLoadingAQ = false;
                    if (typeof internalFolderId === 'number') {
                        this.isLoadingNestedByFolder[folderIdKey] = false;
                        this.folderData[internalFolderId] = data.topics; // Store data for the specific folder
                        if (this.returnFolderData) {
                            //this.previousDataService.emitCallAllTopicDataClickEvent(this.recentSearchQueryList);
                            if (!this.isGyanSelected && this.isFolderActive(internalFolderId)) {
                                this.recentSearchQueryList = JSON.parse(JSON.stringify(data.topics));
                                this.previousDataService.emitCallAllTopicDataClickEvent(this.recentSearchQueryList);
                            }
                        } else {
                            //this.previousAdvanceQueryList = data.topics;
                        }
                    } else {
                        console.log('---------------previousAdvanceQueryList', this.previousAdvanceQueryList);
                        this.previousAdvanceQueryList = data.topics; // Store data for "All"
                        this.recentSearchQueryList = JSON.parse(JSON.stringify(data.topics));
                        this.previousDataService.emitCallAllTopicDataClickEvent(this.recentSearchQueryList);
                        // if (!this.isGyanSelected) {
                        //     this.previousDataService.emitCallAllTopicDataClickEvent(this.recentSearchQueryList);
                        // }
                    }
                    this.hoverState['adavanceQuery'] = false;
                    this.toggleColor('adavanceQuery');
                    this.removeDisabled = true;
                    this.isLoadingadvanceQueryList = false;
                    this.isTopicLoading = false;
                    this.previousDataService.emitLoadingClickEvent(false);
                    console.log('toggleNode.folderData', this.folderData);
                    this.cdr.detectChanges();

                    //due loading delay we need to get this parameter on advance reseach click
                    // this.preWarmACIPermission = this.authService.getAccessList('PreWarmACI');
                    // if (this.preWarmACIPermission) {
                    //     this.notifytoupprewarmingaci();
                    // }
                },
                (error: any) => {
                    this.isLoadingAQ = false;
                    this.isLoadingNestedByFolder[folderIdKey] = false;
                    console.log(error);
                    this.toastrService.error(error.message);
                    this.isTopicLoading = false;
                    this.previousDataService.emitLoadingClickEvent(false);
                },
            );
        }
    }

    findByName(data: string) {
        this.isTopicLoading = true;
        this.previousDataService.emitLoadingClickEvent(true);
        this.previousAdvanceQueryList = [];
        this.countIncr++;
        const counting = this.countIncr;
        if (data != '') {
            const reqBody = {
                filters: {
                    gyanFamily: ['ADVANCED', 'TEMPLATE', 'SENTENCE'],
                    offset: '0',
                    limit: '20',
                    orderBy: 'date',
                    order: 'desc',
                    folderId: this.folderId,
                },
                isViewAll: 'true',
                searchFrom: 'All Searches',
                searchText: data,
            };

            if (this.folderId) {
                reqBody.filters['folderId'] = this.folderId;
            }

            this.previousDataService.getFindByName(reqBody).subscribe(
                (res: any) => {
                    this.isTopicLoading = false;
                    this.metaData = res.metadata;
                    this.totalCount = this.metaData.totalSearches;
                    this.findByNameOffset = res.metadata.offset;
                    if (this.countIncr == counting) {
                        this.previousAdvanceQueryList = res.topics;
                        this.recentSearchQueryList = JSON.parse(JSON.stringify(res.topics));
                        this.previousDataService.emitCallAllTopicDataClickEvent(this.recentSearchQueryList);
                    }
                    this.previousDataService.emitLoadingClickEvent(false);
                    //this.searchText = '';
                },
                (err: any) => {
                    this.isTopicLoading = false;
                    this.previousDataService.emitLoadingClickEvent(false);
                    console.log('err', err);
                },
            );
        } else {
            this.advanceQueryAll('');
        }
    }

    callFindByName() {
        this.topicDetailsOffset = 0;
        this.isTopicLoading = true;
        this.previousDataService.emitLoadingClickEvent(true);
        const reqBody = {
            filters: {
                gyanFamily: ['ADVANCED', 'TEMPLATE', 'SENTENCE'],
                offset: this.findByNameOffset,
                limit: '20',
                orderBy: 'date',
                order: 'desc',
                folderId: this.folderId,
            },
            isViewAll: 'true',
            searchFrom: 'All Searches',
            searchText: this.searchText,
        };

        this.previousDataService.getFindByName(reqBody).subscribe(
            (res) => {
                this.findByNameOffset = res.metadata.offset;
                this.previousAdvanceQueryList = [...this.previousAdvanceQueryList, ...res.topics];
                this.recentSearchQueryList = JSON.parse(JSON.stringify([...this.previousAdvanceQueryList, ...res.topics]));
                this.previousDataService.emitCallAllTopicDataClickEvent(this.recentSearchQueryList);
                this.isTopicLoading = false;
                this.previousDataService.emitLoadingClickEvent(false);
            },
            (err) => {
                console.log('err', err);
                this.isTopicLoading = false;
                this.previousDataService.emitLoadingClickEvent(false);
            },
        );
    }

    notifytoupprewarmingaci() {
        // console.log("notifytoupprewarmingaci called");
        this.previousDataService.notifytoupprewarmingaci().subscribe((data: any) => {
            console.log('data', data);
        });
    }

    previousSearch() {
        this.isLoadingPreviousGyanAllList = false;
        this.isLoadingPreviousGyanList = true;
        this.previousDataService.getPreviousGyanData(this.json).subscribe((data: any) => {
            if (data.statusCode === 200) {
                this.isLoadingPreviousGyanAllList = false;
                this.isLoadingPreviousGyanList = false;
                if (this.previousGyanList === null || this.previousGyanList === undefined || JSON.stringify(this.previousGyanList) === '{}') {
                    this.previousGyanList = data.data;
                } else {
                    data.data.eachGyanResponseList.forEach((item: any) => {
                        const index = this.previousGyanList.eachGyanResponseList.findIndex((nitem: any) => nitem.rootNodeId === item.rootNodeId);
                        if (index !== -1) {
                            // Replace the object with the updated one
                            this.previousGyanList.eachGyanResponseList[index] = item;
                        } else {
                            this.previousGyanList.eachGyanResponseList.push(item);
                        }
                    });
                }
                this.lastResultCount = data.data.eachGyanResponseList.count;
                this.hoverState['previousSearch'] = false;
                this.toggleColor('previousSearch');
                this.removeDisabled = true;
                // this.isLoadingPreviousGyanList = false;
            }
        });
        if (this.previousGyanList.eachGyanResponseList.length === 0) {
            this.gotoDashboardhome();
        }
    }

    AdvanceQuery() {
        this.isTopicLoading = true;
        this.previousDataService.emitLoadingClickEvent(true);
        this.previousDataService.getAdvanceQueryData(this.json1).subscribe((data: any) => {
            this.isLoadingAQ = false;
            console.log('-------', data);
            console.log('-------', this.previousAdvanceQueryList);
            if (data.topics.length > 0) {
                if (this.previousAdvanceQueryList === null || this.previousAdvanceQueryList === undefined || JSON.stringify(this.previousAdvanceQueryList) === '{}') {
                    this.previousAdvanceQueryList = data.topics;
                    this.recentSearchQueryList = JSON.parse(JSON.stringify(data.topics));
                } else {
                    console.log('-------', this.previousAdvanceQueryList);
                    data.topics.forEach((item: any) => {
                        console.log(item);
                        const index = this.previousAdvanceQueryList.findIndex((nitem: any) => nitem.topicId === item.topicId);
                        console.log(index);
                        if (index !== -1) {
                            // Replace the object with the updated one
                            this.previousAdvanceQueryList[index] = item;
                            this.recentSearchQueryList = JSON.parse(JSON.stringify(this.previousAdvanceQueryList));
                        } else {
                            this.previousAdvanceQueryList.push(item);
                            this.recentSearchQueryList = JSON.parse(JSON.stringify(this.previousAdvanceQueryList));
                        }
                    });
                }
                this.previousDataService.emitCallAllTopicDataClickEvent(this.recentSearchQueryList);
                console.log('-------', this.previousAdvanceQueryList);
                this.lastResultCount = data.data?.previousAdvanceQueryList.count;
                this.hoverState['advanceSearch'] = false;
                this.toggleColor('advanceSearch');
                this.removeDisabled = true;
                this.isLoadingAQ = false;
                this.isLoadingadvanceQueryList = false;
                this.isTopicLoading = false;
                this.previousDataService.emitLoadingClickEvent(false);
            } else {
                this.isTopicLoading = false;
                this.previousDataService.emitLoadingClickEvent(false);
            }
        });
        if (this.previousAdvanceQueryList.eachadvanceQueryResponseList?.length === 0) {
            this.gotoDashboardhome();
        }
    }
    openLogInModal(): void {
        this.logInModal.openLogInModal();
    }
    openSignUpModal(): void {
        this.signUpModal.openSignUpModal();
    }
    UserSignIn() {
        console.log('Signed In');
    }
    isSignInUser() {
        //add a local variable and set it to - advanced
        if (this.authService.isSignInUser()) this.signInUser = true;
        else this.signInUser = false;
        return this.authService.isSignInUser();
    }
    showPopover: boolean = false;

    showTooltip(event: MouseEvent): void {
        const tooltip = (event.target as HTMLElement).querySelector('.custom-tooltip') as HTMLElement;
        if (tooltip) {
            tooltip.style.visibility = 'visible';
            tooltip.style.opacity = '1';
        }
    }

    hideTooltip(event: MouseEvent): void {
        const tooltip = (event.target as HTMLElement).querySelector('.custom-tooltip') as HTMLElement;
        if (tooltip) {
            tooltip.style.visibility = 'hidden';
            tooltip.style.opacity = '0';
        }
    }
    isPreviousSearchOpen: boolean = false;
    isAdvanceQueryOpen: boolean = false;
    isContentOpen: boolean = false;
    isDraftOpen: boolean = false;
    advanceClick() {
        this.localStorageService.setItem('rootGyanId', '');
        if (!this.isLoadingPreviousGyanAllList) {
            console.log('inside isLoadingPreviousGyanAllList');
            if (this.isPreviousSearchOpen) {
                this.isPreviousSearchOpen = !this.isPreviousSearchOpen;
            }
            if (this.isSignInUser() && !this.isPreviousSearchOpen) {
                this.isLoadingAQ = this.previousAdvanceQueryList.length === 0;

                //calling perWarm onclick
                this.preWarmACIPermission = this.authService.getAccessList('PreWarmACI');
                if (this.preWarmACIPermission) {
                    this.notifytoupprewarmingaci();
                }
                this.onAdvancedQueryClick();
                //this.isGyanSelected = false;
            }
        }
    }
    onAdvancedQueryClick() {
        console.log('inside onAdvancedQueryClick');
        //added this because of the need to remove gyanData from session which is coming from find more aricle to advanced reasech to prepopulate the topic and also need to remove if we directly click on advanced research everytime.
        this.isDraftOpen = false;
        this.localStorageService.removeItem('gyanData');
        this.breadcrumbService.updateBreadcrumbs([]);
        this.folderId = '';
        this.isExpanded = { all: true };
        this.folderActiveState = {};
        this.refreshThepreviousAdvanceQueryList();
        const gyanData = {
            gyanType: 'gyan',
        };
        this.localStorageService.setItem('gyanData', gyanData);

        this.renamingNodeIdadvanceQuery = null;
        this.advanceQueryLocaldata = null;
        // debugger;
        this.commonServiceService.setopenSubmitGyan(true);

        // Toggle the state of advanced query and previous search sections
        if (this.isGyanSelected) {
            this.isGyanSelected = false;
        } else {
            if (this.previousAdvanceQueryList.length > 0 && this.isAdvanceQueryOpen) {
                this.isPreviousSearchOpen = false; // Toggle based on isAdvanceQueryOpen

                //this.advanceQueryAll();
                //this.previousDataService.emitCallAllTopicDataClickEvent(this.recentSearchQueryList);
            } else {
                console.log('else else condition');
                this.isAdvanceQueryOpen = !this.isAdvanceQueryOpen;
                this.isPreviousSearchOpen = false; // Toggle based on isAdvanceQueryOpen
                this.isLoadingAQ = false;
                if (this.isAdvanceQueryOpen) {
                    this.advanceQueryAll('');
                }
            }
        }
        setTimeout(() => {
            this.previousDataService.emitCallAllTopicDataClickEvent(this.previousAdvanceQueryList);
            console.log('recentSearchQueryList[0]', this.previousAdvanceQueryList[0]);
            this.previousAdvanceQueryList = [...this.previousAdvanceQueryList];
            this.cdr.detectChanges();
        }, 100);
    }
    isLoadingAQ: boolean = false;
    onPreviousGyanClick() {
        this.isLoadingAQ = false;
        this.renamingNodeId = null;
        this.gyanLocaldata = null;
        this.localStorageService.setItem('rootGyanId', '');
        // Toggle previous search

        // Check if there is any previous Gyan and select the latest one
        // if (this.previousGyanList.eachGyanResponseList.length > 0) {
        //     const latestGyan = this.previousGyanList.eachGyanResponseList[0];
        //     //this.previousGyanSelected(latestGyan.name, latestGyan.rootNodeId);
        //     this.previousGyanSelectedGeneral(latestGyan.name, latestGyan.rootNodeId);
        // }
        // //  for go to dashboardhome
        if (!this.isPreviousSearchOpen) {
            this.gotoDashboardhome();
        }
        this.isPreviousSearchOpen = !this.isPreviousSearchOpen;
        this.isPreviousListOpen = true;
        if (this.isPreviousSearchOpen && !this.isLoadPreviousGyanList) {
            this.isLoadPreviousGyanList = true; // Set a flag to prevent future calls
            this.previousSearchAll();
        }
        // Ensure the advanced query is closed

        /* eslint-disable sonarjs/no-redundant-boolean */
        this.isAdvanceQueryOpen = false;
        // if (this.isPreviousSearchOpen) {
        //     //this.previousSearchAll();
        //     this.gotoDashboardhome();
        //     this.isLoadingAQ = false;
        // }
        this.isDraftOpen = false;
        this.isGyanSelected = false;
        this.commonServiceService.setCallfromSocketForMDS(false);
    }

    getSignInUser() {
        return this.authService.getSignInUser();
    }
    logout() {
        this.authService.logout();
    }
    resetPassword() {
        this.authService.forgotPassword();
    }
    splitText(title: string) {
        if (title !== null && title !== undefined && title.length > 30) {
            title = title.slice(0, 30) + '..';
        }
        return title;
    }
    menuOpen: boolean = false;
    closeOption() {
        if (this.menuOpen) {
            const optionsMenus = document.querySelectorAll('.comment-box-menu-icon') as NodeListOf<HTMLElement>;
            if (!optionsMenus) return; // Check if optionsBoxes is null
            // Hide all other open options boxes
            optionsMenus.forEach((box) => {
                //if (box !== currentTarget.nextElementSibling) {
                box.classList.remove('comment-box-menu-icon-select');
                //box.previousElementSibling.classList.remove('comment-box-menu-icon-select');
                // }
            });

            const optionsBoxes = document.querySelectorAll('.options-box') as NodeListOf<HTMLElement>;
            if (!optionsBoxes) return; // Check if optionsBoxes is null
            optionsBoxes.forEach((box) => {
                box.classList.remove('show');
            });
            this.menuOpen = false;
        }
    }
    onButtonClick(event: MouseEvent) {
        event.stopImmediatePropagation();
        this.menuOpen = true;

        const currentTarget = event.currentTarget as HTMLElement;
        console.log(' >> currentTarget << ');
        console.log(currentTarget);
        console.log(' >> currentTarget << ');
        const x = event.clientX;
        const y = event.clientY;
        console.log(' >> currentTarget >> x' + x);
        console.log(' >> currentTarget >> y' + y);
        if (!currentTarget) return; // Check if currentTarget is null
        const optionsBoxes = document.querySelectorAll('.options-box') as NodeListOf<HTMLElement>;
        if (!optionsBoxes) return; // Check if optionsBoxes is null
        // Hide all other open options boxes
        optionsBoxes.forEach((box) => {
            if (box !== currentTarget.nextElementSibling) {
                box.classList.remove('show');
                //box.style.setProperty('left',y.toString());
                //box.previousElementSibling.classList.remove('comment-box-menu-icon-select');
            }
        });

        const optionsMenus = document.querySelectorAll('.comment-box-menu-icon') as NodeListOf<HTMLElement>;
        if (!optionsMenus) return; // Check if optionsBoxes is null
        // Hide all other open options boxes
        optionsMenus.forEach((box) => {
            //if (box !== currentTarget.nextElementSibling) {
            box.classList.remove('comment-box-menu-icon-select');
            //box.previousElementSibling.classList.remove('comment-box-menu-icon-select');
            // }
        });

        const optionsBox = currentTarget.nextElementSibling;
        if (!optionsBox) return; // Check if optionsBox is null
        optionsBox.classList.toggle('show');
        const rect = (event.target as HTMLElement).getBoundingClientRect();
        (optionsBox as HTMLElement).style.setProperty('top', (rect.bottom + window.scrollY).toString() + 'px');
        //(optionsBox as HTMLElement).style.setProperty('left', ((optionsBox as HTMLElement).getBoundingClientRect().left + window.scrollX).toString() + 'px');

        currentTarget.classList.add('comment-box-menu-icon-select');
        if (optionsBox.classList.contains('show')) {
            this.globalClickListener = this.renderer.listen('document', 'click', (clickEvent: MouseEvent) => {
                if (!optionsBox.contains(clickEvent.target as HTMLElement) && !currentTarget.contains(clickEvent.target as HTMLElement)) {
                    const optionsMenus = document.querySelectorAll('.comment-box-menu-icon') as NodeListOf<HTMLElement>;
                    if (!optionsMenus) return; // Check if optionsBoxes is null
                    // Hide all other open options boxes
                    optionsMenus.forEach((box) => {
                        //if (box !== currentTarget.nextElementSibling) {
                        box.classList.remove('comment-box-menu-icon-select');
                        //box.previousElementSibling.classList.remove('comment-box-menu-icon-select');
                        // }
                    });

                    optionsBox.classList.remove('show');
                    this.globalClickListener(); // Remove the listener once it's no longer needed
                }
            });
        } else {
            if (this.globalClickListener) {
                this.globalClickListener();
            }
        }
    }
    menuTrigger: any;
    @ViewChild('specificDivBox') specificDivBox!: ElementRef;
    @ViewChild('specificDivBoxControl') specificDivBoxControl!: ElementRef;

    closeMenuOnOutsideClick() {
        this.renderer.listen('window', 'click', (event: Event) => {
            if (
                this.isMobile &&
                this.isHideTab &&
                !((this.specificDivBox && this.specificDivBox.nativeElement.contains(event.target)) || this.specificDivBoxControl.nativeElement.contains(event.target))
            ) {
                // Trigger your event here
                this.hideTab();
            }
            if (this.menuOpen && !this.elementRef.nativeElement.contains(event.target)) {
                this.closeOption();
                this.menuOpen = false;
                if (this.globalClickListener) {
                    this.globalClickListener();
                }
            }
        });
    }
    toggleColor(itemName: any) {
        const selectedItem = this.selectedList.find((item) => item.name === itemName);
        if (selectedItem) {
            selectedItem.isBlack = !selectedItem.isBlack;
        }
        this.selectedList.forEach((item) => {
            if (item.name !== itemName) {
                item.isBlack = false;
            }
        });
    }
    isItemBlack(itemName: string) {
        const selectedItem = this.selectedList.find((item) => item.name === itemName);
        return selectedItem ? selectedItem.isBlack : false;
    }
    toggleHover(itemName: string, state: boolean) {
        this.hoverState[itemName] = state;
    }
    @ViewChild(GetproComponent) GetproInstance!: GetproComponent;
    openGetproModal(): void {
        //  this.GetproInstance.openGetproModal();
        this.GetproModal.openGetproModal();
    }
    checkWidth() {
        const width = window.innerWidth;
        console.log(width);
        if (width < 768) this.isMobile = true;
        else this.isMobile = false;
    }

    gotoDashboardhome() {
        // debugger;
        this.localStorageService.setItem('rootGyanId', '');
        this.gyanLocaldata = null;
        this.advanceQueryLocaldata = null;
        this.isAdvanceQueryOpen = false;
        this.isPreviousListOpen = false;
        this.isPreviousSearchOpen = false;
        const obj = {
            callMDS: false,
            callArticles: false,
        };

        //changing this gyanType to Rapid to make the searchbar appear in home page
        const gyanData = { gyanType: 'rapid' };
        this.localStorageService.setItem('gyanData', gyanData);
        this.commonServiceService.setPreviousGyanClick(obj);
        this.commonServiceService.setPreviousadvanceQueryClick(obj);
        this.commonServiceService.setgotoDashboard(true);
    }

    callGetTopicHierarchy(topicId: number) {
        console.log('.........callGetTopicHierarchy');
        // this.topicOutline = [];
        this.articleService.getTopicHierarchy(this.gyanVersion, topicId).subscribe(
            (res) => {
                this.isGyanSelected = true;
                this.localStorageService.setItem('rootGyanId', res[0].id);
                console.log('callGetTopicHierarchy.getTopicHierarchy.res', res[0]);
                this.topicOutline = res[0];
                if (this.isExpanded['all']) {
                    this.toggleNode({ topicId: 'all' }, null);
                }
                this.rootTopicId = this.localStorageService.getItem('rootGyanId');
                this.articleService.emitCallTopicHierarchyEvent(res[0]);
            },
            (err) => {
                console.log(err);
            },
        );
    }

    selectTopic(topic: any) {
        this.resetSize();
        this.localStorageService.removeItem('articleClickIndex');
        console.log('the selected topic is', topic);
        this.selectedTopic = topic;
        this.topicOutlineSelected(topic, false);
    }

    isSelected(topic: any): boolean {
        return this.selectedTopic === topic;
    }

    topicOutlineSelected(topic: any, clickType: boolean) {
        this.resetSize();
        if (clickType) {
            this.selectedTopic = null;
        }
        this.localStorageService.removeItem('articleClickIndex');

        console.log('topicOutlineSelected.topic', topic);
        //this.gyanLocaldata = this.localStorageService.getItem('gyanData');
        this.gyanLocaldata = this.localStorageService.getItem('gyanData');
        console.log('topicOutlineSelected.gyanLocaldata', this.gyanLocaldata);
        this.rootStatus = this.gyanLocaldata.gyanStatus;
        //this.AdvanceQuerySelected(topic.text, topic.id, topic.taskStatus);
        // if(this.rootStatus == 6) {
        // this.rootStatus = this.gyanLocaldata.gyanStatus;
        // }else if(this.rootStatus == 1)
        // {
        //     this.rootStatus = 'RUNNING'
        // }
        this.previousadvanceQuerySelectedGeneral(topic.text, topic.id, this.rootStatus, 'topic');
        if (this.isMobile) {
            this.hideTab();
        }
    }

    ngOnDestroy() {
        this.callPreviousSearchGyan.unsubscribe();
        if (this.globalClickListener) {
            this.globalClickListener();
        }
        this.scrollToTop.unsubscribe();
        this.RefreshAdvancedQueries.unsubscribe();
        this.showAdvancyQueryFormPage.unsubscribe();

        this.topicClickEvent.unsubscribe();
        this.callAllTopicDetailsEvent.unsubscribe();
        this.callFindByNameEvent.unsubscribe();
        this.callSubmitGyanEvent.unsubscribe();
        this.callTopicDetailsEvent.unsubscribe();
        this.callTopicUpdateEvent.unsubscribe();
        this.callAllTopicWithParamEvent.unsubscribe();
    }

    OpenContent() {
        const a = document.createElement('a');
        a.href = environment.cmsContentUrl;
        a.target = '_blank';
        a.click();
    }

    openDraft() {
        this.isDraftOpen = true;
        this.isGyanSelected = false;
        this.localStorageService.removeItem('gyanData');
        this.commonServService.setShowDraftListPage(true);
    }

    updateTopicArrayFunction(topicId: any, topicName: string, type: string, parentFolderId: any) {
        console.log('updateTopicArray.topicId', topicId);
        console.log('updateTopicArray.topicName', topicName);
        console.log('updateTopicArray.type', type);
        console.log('updateTopicArray.parentFolderId', parentFolderId);
        // if (!this.isFolderActive(parentFolderId)) {
        //     parentFolderId = '';
        // }
        console.log('updateTopicArray.parentFolderId.1', parentFolderId);

        // Helper function to update/delete topic in a list
        const updateList = (list: Array<any>, listName: string) => {
            const index = list?.findIndex((selectedTag: any) => selectedTag.topicId == topicId);
            console.log('updateTopicArray.index', index);
            if (index === -1 || index == null) return; // Exit if topic not found
            const item = list[index];
            if (type === 'delete') {
                // console.log('updateTopicArray.delete');
                // list.splice(index, 1);
            } else if (type === 'rename') {
                list[index] = { ...list[index], topicName: topicName };
            }
            console.log(`updateTopicArray.${listName}[index]`, list[index]);
        };

        // Update recentSearchQueryList
        updateList(this.recentSearchQueryList, 'recentSearchQueryList');

        // Update folderData or previousAdvanceQueryList based on parentFolderId
        if (parentFolderId) {
            if (this.folderData[parentFolderId]) {
                console.log('updateTopicArray.folderData[parentFolderId]', this.folderData[parentFolderId]);
                updateList(this.folderData[parentFolderId], `folderData[${parentFolderId}]`);
            }
        } else {
            updateList(this.previousAdvanceQueryList, 'previousAdvanceQueryList');
        }

        // Trigger necessary updates
        setTimeout(() => {
            this.previousDataService.emitCallAllTopicDataClickEvent(this.recentSearchQueryList);
            this.cdr.detectChanges();
        }, 100);
    }

    updateTopicMoveArrayFunction(topicId: any, sourceFolderId: any, destinationFolderId: any) {
        console.log('updateTopicMoveArray.move.topicId', topicId);
        console.log('updateTopicMoveArray.move.sourceFolderId', sourceFolderId);
        console.log('updateTopicMoveArray.move.destinationFolderId', destinationFolderId);
        console.log('updateTopicMoveArray.move.folderData', this.folderData);

        // Helper function to move a single topicId
        const moveTopic = (topicId: any) => {
            console.log('Processing topicId:', topicId);

            // Ensure both source and destination folders exist in folderData
            let sourceList = this.folderData[sourceFolderId];
            const destinationList = this.folderData[destinationFolderId];

            console.log('updateTopicMoveArray.move.sourceList', sourceList);

            if (!sourceList) {
                console.error('updateTopicMoveArray.Source folder not found in folderData');
                sourceList = this.previousAdvanceQueryList;
            }

            // Find the item in the source folder by topicId
            const index = sourceList.findIndex((item: any) => item.topicId === topicId);
            console.log('updateTopicMoveArray.move.index', index);

            if (index !== -1) {
                // Remove the item from the source folder
                const [item] = sourceList.splice(index, 1);
                console.log('updateTopicMoveArray.move.[item]', [item]);

                this.previousDataService.emitCallAllTopicDataClickEvent(sourceList);

                if (destinationList) {
                    // Insert the item at the top of the destination folder if it exists
                    destinationList.unshift(item);
                    console.log('updateTopicMoveArray.Item moved to destination successfully:', item);
                } else {
                    // If destination folder not found, just remove the item from source
                    console.log('updateTopicMoveArray.Destination folder not found. Item removed from source only:', item);
                }
            } else {
                console.log('updateTopicMoveArray.TopicId not found in source folder');
            }
        };

        // Check if topicId is an array or a string
        if (Array.isArray(topicId)) {
            // Loop through the array of topicIds and call moveTopic for each
            topicId.forEach((id: any) => moveTopic(id));
        } else {
            // Handle a single topicId
            moveTopic(topicId);
        }
        this.advanceQueryAll(destinationFolderId);
    }

    updateTopicDeleteArrayFunction(topicId: any) {
        const folderId: any = this.findFolderByTopicId(topicId);
        console.log('updateTopicDeleteArray.folderId', folderId);
        if (!folderId) {
            console.error('updateTopicDeleteArray.Source folderis Null Redirect to Home');
            this.folderId = '';
            this.advanceQueryAll('');
            this.currentTopicPath = [];
            this.breadcrumbService.updateBreadcrumbs(this.currentTopicPath);
        }
        let sourceList = this.folderData[folderId];
        if (!sourceList) {
            console.error('updateTopicDeleteArray.Source folder not found in folderData');
            sourceList = this.previousAdvanceQueryList;
        }

        // Find the item in the source folder by topicId
        const index = sourceList.findIndex((item: any) => item.topicId === topicId);
        if (index !== -1) {
            const topic = sourceList[index];
            console.log('updateTopicDeleteArray.topic', topic);
            if (topic.isFolder) {
                // Find the index of the object with the matching topicId
                const pathIndex = this.currentTopicPath.findIndex((path: any) => path.topicId === topic.topicId);
                console.log('updateTopicDeleteArray.topic.pathIndex', pathIndex);

                if (pathIndex !== -1) {
                    // Remove the item from the array using splice if found
                    this.currentTopicPath.splice(pathIndex);
                    this.breadcrumbService.updateBreadcrumbs(this.currentTopicPath);

                    const activeFolder = this.currentTopicPath[this.currentTopicPath.length - 1];
                    console.log('updateTopicDeleteArray.activeFolder', activeFolder);
                    this.folderId = activeFolder.topicId;
                    this.highlightFolder(activeFolder.topicId);
                    //this.closeAllFolders();
                    //console.log('callTopicDetailsEvent.topcicId', topcicId);
                    this.advanceQueryAll(activeFolder.topicId);
                }
            }
            // Remove the item from the source folder
            sourceList.splice(index, 1);
        } else {
            console.log('updateTopicDeleteArray.TopicId not found in source folder');
        }
        const topic = this.currentTopicPath[this.currentTopicPath.length - 1];
        if (topic) {
            this.advanceQueryAll(topic.topicId);
        } else {
            this.refreshThepreviousAdvanceQueryList();
            this.advanceQueryAll('');
        }
        // setTimeout(() => {
        //     this.previousAdvanceQueryList = [];
        //     this.cdr.detectChanges();
        // }, 100);
    }

    moveGyanItem(item: any) {
        console.log('Dashboard.moveGyanItem.item', item);
        this.closeOption();
        this.previousDataService.emitMoveClickEvent(item);
    }

    clearMoveBreadcrumb() {
        this.currentPath = [];
        this.moveBreadcrumbService.updateBreadcrumbs(this.currentPath);
    }

    onBreadcrumbClick(index: any) {
        const clickFolder = this.currentPath[index];
        const folderId = clickFolder.folderId;
        this.fetchMoveFoldersList(folderId);
        this.currentPath = this.currentPath.slice(0, index + 1);
        this.currentFolders = this.currentPath.length ? this.currentPath[index].children : [];
        this.moveBreadcrumbService.updateBreadcrumbs(this.currentPath);
    }

    fetchMoveFoldersList(folderId: any) {
        this.moveError = '';
        this.errorFetchingFolder = '';
        this.showMoveLoader = true;
        this.selectedFolderId = folderId;
        this.previousDataService.fetchFoldersList(folderId).subscribe(
            (response: any) => {
                if (response) {
                    this.showMoveLoader = false;
                    const selectedIds = this.multiSelected.map((item: any) => {
                        return item.topicId;
                    });
                    if (this.multiSelected.length === 0 && this.selecteditem) {
                        selectedIds.push(this.selecteditem?.topicId);
                    }
                    // console.log('fetchMoveFoldersList.multiSelected', this.multiSelected);
                    // console.log('fetchMoveFoldersList.selectedIds', selectedIds);
                    //console.log('fetchMoveFoldersList.selectedIds', folders);
                    const folders = response.map((folder: any) => {
                        return {
                            ...folder,
                            isDisabled: selectedIds.includes(folder.folderId) ? true : false,
                        };
                    });
                    this.previousDataService.updateFolderList(folders);
                    console.log('fetchMoveFoldersList.folders', folders);
                    //this.currentFolders = folders;
                    //this.previousDataService.updateFolderList(response);
                    //this.changeDetection.detectChanges();
                }
            },
            (error: any) => {
                this.showMoveLoader = false;
                console.log(error);
                this.errorFetchingFolder = 'There was error in listing the folders';
            },
        );
    }

    onAllClick() {
        console.log('onAllClick.org');
        this.currentPath = [];
        this.currentFolders = [];
        this.moveBreadcrumbService.updateBreadcrumbs(this.currentPath);
        this.fetchMoveFoldersList(null);
    }

    onFolderClick(folder: any) {
        this.fetchMoveFoldersList(folder.folderId);
        this.currentPath.push(folder);
        this.currentFolders = folder.children || [];
        this.moveBreadcrumbService.updateBreadcrumbs(this.currentPath);
        this.showBreadcrumb = false;
    }

    moveGyan() {
        console.log('moveFolder.multiSelected', this.multiSelected);
        console.log('moveFolder.selecteditem', this.selecteditem);
        console.log('moveFolder.folderId', this.folderId);
        this.showMoveLoader = true;

        const topicIdArray = this.multiSelected.map((item) => item.topicId);
        if (this.multiSelected.length === 0 && this.selecteditem) {
            topicIdArray.push(this.selecteditem?.topicId);
        }
        console.log('moveFolder.topicIdArray', topicIdArray);
        if (topicIdArray.length > 0) {
            const folderId = this.findFolderByTopicId(this.selecteditem.topicId);
            console.log('moveFolder.folderId', folderId);
            if (this.selectedFolderId === folderId) {
                this.moveError = 'The Gyan/Folder already exists in this folder';
                this.showMoveLoader = false;
                return;
            }
            const reqBody = {
                //gyanId: this.selecteditem.topicId,
                gyanIds: topicIdArray,
                folderId: this.selectedFolderId,
                parentFolderId: folderId || '',
            };
            console.log('moveFolder.reqBody', reqBody);
            this.previousDataService.moveGyan(reqBody).subscribe(
                (response) => {
                    console.log('moveFolder.response', response);
                    if (response) {
                        this.closeMoveModal();
                        this.multiSelected = [];
                        this.showMoveLoader = false;
                        this.clearMoveBreadcrumb();
                        this.toastrService.success(response.message);
                        this.updateTopicMoveArrayFunction(this.selecteditem.topicId, folderId, this.selectedFolderId);
                        // if (!this.isGyanSelected) {
                        //
                        //     //this.callTopicDetailsClick();
                        // } else {
                        //     this.updateTopicArray(this.selecteditem.topicId, this.selecteditem.topicName, 'move', this.selectedFolderId);
                        // }
                        this.selecteditem = null;
                        // this.selectedItemsEvent.emit(this.multiSelected);
                        // this.callGetMyTopicDetails.emit(this.folderId);
                    }
                },
                (error) => {
                    console.log(error);
                    this.showMoveLoader = false;
                    //this.selecteditem = null;
                    //this.toastrService.error(error.error.message);
                    this.moveError = error.error.message;
                    //this.moveError = 'There was error in moving the item';
                    //this.toastr.error('There was error in moveGyan the item');
                },
            );
        } else {
            this.moveError = 'There was No Gyan / Folder selected to move';
        }
    }

    closeMoveModal() {
        this.isMoveItemActive = false;
        if (this.modalRef) {
            this.modalRef.close();
        }
    }

    callTopicDetailsClick() {
        console.log('moveFolder.callTopicDetailsClick.currentTopicPath', this.currentTopicPath);

        if (this.currentTopicPath.length > 0) {
            console.log('moveFolder.callTopicDetailsClick.if');
            const topic = this.currentTopicPath[this.currentTopicPath.length - 1];
            console.log('moveFolder.topic', topic);
            this.folderId = topic.topicId;
            console.log('moveFolder.callTopicDetailsClick.this.folderId', this.folderId);
            this.advanceQueryAll('');
            //this.previousDataService.emitCallTopicDetailsClickEvent(topic.topicId);
        } else {
            console.log('moveFolder.callTopicDetailsClick.else');
            this.advanceQueryAll('');
            //this.previousDataService.emitCallAllTopicDetailsClickEvent();
        }
    }

    showMovePopup(item: any, content: any, popupSize: string): void {
        this.closeOption();
        //this.folderId = '';
        //this.folderActiveState = {};
        //this.advanceQueryLocaldata = null;
        this.fetchMoveFoldersList(null);
        if (item) {
            this.selecteditem = item;
        }
        this.modalRef = this.modalService.open(content, { size: popupSize, windowClass: 'custom-modal-class move-modal' });
        console.log('showMovePopup.multiSelected', this.multiSelected);
        console.log('showMovePopup.selecteditem', this.selecteditem);
    }

    checkIfIconShouldBeVisible(folderId: number) {
        return !!(this.folderData[folderId] && this.folderData[folderId].length === 0);
    }

    closeAllFolders() {
        console.log('closeAllFolders.called');
        Object.keys(this.folderData).forEach((folderId: any) => {
            if (this.isFolderActive(folderId)) {
                console.log('closeAllFolders.isFolderActive');
            } else {
                delete this.folderData[folderId];
            }
        });
        console.log('closeAllFolders.called', this.folderData);
    }

    findFolderByTopicId(topicId: any) {
        // Loop through the folderData object
        if (this.folderData) {
            for (const folderId in this.folderData) {
                if (this.folderData.hasOwnProperty(folderId)) {
                    const folderList = this.folderData[folderId];

                    // Check if the topicId exists in the folder's list
                    const found = folderList.some((item: any) => item.topicId === topicId);

                    if (found) {
                        // Return the folderId (key) where the topicId was found
                        return folderId;
                    }
                }
            }
        }

        // If the topicId is not found in any folder, return null or undefined
        return null;
    }

    refreshThepreviousAdvanceQueryList() {
        const previousAdvanceQueryListOriginal = JSON.parse(JSON.stringify(this.previousAdvanceQueryList));
        this.previousAdvanceQueryList = [];
        setTimeout(() => {
            this.isAdvanceQueryOpen = true;
            this.isPreviousSearchOpen = false;
            this.previousAdvanceQueryList = [...previousAdvanceQueryListOriginal];
            this.cdr.detectChanges();
        }, 0);
    }
}
